import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { ComponentProps, FC } from 'react';
import { BasketDrawerConnected } from './BasketDrawerConnected';
import { BasketDrawerV2Connected } from './v2';

type Props = ComponentProps<typeof BasketDrawerConnected>;

export const BasketDrawerVersion: FC<Props> = (props) => {
  const isV2 = useFeatureIsOn('feature.ecom2');

  if (isV2) {
    return (
      <BasketDrawerV2Connected
        open={props.open}
        onClose={props.onClose}
        propertyModules={props.propertyModules}
      />
    );
  }

  return <BasketDrawerConnected {...props} />;
};
